import React, { useRef, useState } from 'react';
import cn from 'classnames';

import type { TFocusHandler, TYandexSearchBarDesktop } from '../../models';
import { SEARCH_ID, SEARCH_URL } from '../components/config';

export const YandexSearchBarDesktop = ({
    SuggestBlock,
    YandexSearchInput,
    Stack,
    backgroundType = 'default',
    children,
    className,
    classNames,
    containerRef,
    dataTestId,
    inputInnerRef,
    onBlur,
    onFocus,
    onSubmit,
    placeholder = 'Введите запрос',
    styles,
    searchId = SEARCH_ID,
    searchUrl = SEARCH_URL,
    submitButtonText,
    stackingOrder,
    suggestsAmount,
    suggestTitle,
    suggestList,
    theme = 'light',
    iconUrl,
}: TYandexSearchBarDesktop) => {
    const [isFocused, setIsFocused] = useState(false);
    const [zIndexVal, setZindexVal] = useState(stackingOrder.FOCUSED);
    const mainRef = useRef<HTMLDivElement>(null);
    const overlayRef = useRef<HTMLDivElement>(null);
    const showOverlay = () => {
        if (backgroundType !== 'default') {
            overlayRef.current?.classList.add(styles.isOpen);
            setZindexVal(stackingOrder.OVERLAY);
        }
    };
    const removeOverlaySuggestBlock = () => {
        setZindexVal(stackingOrder.FOCUSED);
        overlayRef.current?.classList.remove(styles.isOpen);
    };
    const removeOverlayYandexInput = () => {
        if (backgroundType !== 'default') {
            if (suggestList) return;
            removeOverlaySuggestBlock();
        }
    };
    const onFocusHandler: TFocusHandler = e => {
        onFocus?.(e);
        showOverlay();
    };
    const onBlurHandler: TFocusHandler = e => {
        onBlur?.(e);
        removeOverlayYandexInput();
    };

    return (
        <>
            <Stack value={zIndexVal + 1}>
                {zIndex => (
                    <div ref={mainRef} className={styles.main} style={{ zIndex: zIndex }}>
                        <YandexSearchInput
                            className={className}
                            classNames={classNames}
                            containerRef={containerRef}
                            dataTestId={dataTestId}
                            iconUrl={iconUrl}
                            inputInnerRef={inputInnerRef}
                            isFocused={isFocused}
                            onBlur={onBlurHandler}
                            onFocus={onFocusHandler}
                            onSubmit={onSubmit}
                            placeholder={placeholder}
                            searchId={searchId}
                            searchUrl={searchUrl}
                            setIsFocused={setIsFocused}
                            submitButtonText={submitButtonText}
                            suggestsAmount={suggestsAmount}
                            theme={theme}
                            zIndex={zIndex}
                        >
                            {children}
                        </YandexSearchInput>
                        {suggestList && SuggestBlock && (
                            <SuggestBlock
                                closeOverlay={removeOverlaySuggestBlock}
                                isFocused={isFocused}
                                searchInputRef={mainRef}
                                suggestList={suggestList}
                                suggestTitle={suggestTitle}
                            />
                        )}
                    </div>
                )}
            </Stack>
            <Stack value={stackingOrder.OVERLAY}>
                {zIndex => (
                    <div
                        ref={overlayRef}
                        className={cn(styles.curtains, styles[backgroundType])}
                        data-test-id="background-overlay"
                        style={{ zIndex }}
                    />
                )}
            </Stack>
        </>
    );
};
